import styled, { keyframes } from 'styled-components';

const pathAnimation = keyframes`
  0% {
    transform: rotate(0deg)
  }
  33% {
    transform: rotate(-40deg)
  }
  100% {
    transform: rotate(-40deg)
  }
`;
const ShacklePath = styled.path`
  animation: ${pathAnimation} 0.6s ease-in-out forwards;
  animation-delay: 0.2s;
`;

type Props = { onAnimationEnd: () => void };
export const Padlock = ({ onAnimationEnd }: Props) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      overflow="visible"
    >
      <path
        d="M25.6001 57.6H102.4V115.2H25.6001V57.6Z"
        stroke="white"
        strokeWidth="12.8"
      />
      <ShacklePath
        d="M89.5999 57.6V38.4C89.5999 24.2616 78.1384 12.8 63.9999 12.8V12.8C49.8614 12.8 38.3999 24.2615 38.3999 38.4V57.6"
        stroke="white"
        strokeWidth="12.8"
        style={{
          transformOrigin: '38.3999px 57.6px',
        }}
        onAnimationEnd={onAnimationEnd}
      />
      <path d="M51.2 86.4H76.8" stroke="white" strokeWidth="12.8" />
    </svg>
  );
};
